import React, { useEffect, useRef, useState } from 'react';
import { gsap, ScrollTrigger } from '../../lib/gsap';
import { experienceData } from '../../data/experienceData';
import './Experience.css';

function Experience() {
  const sectionRef = useRef(null);
  const trackRef = useRef(null);
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    const cards = gsap.utils.toArray('.exp-stack-card');
    if (isMobile || cards.length < 2) return undefined;

    let currentIdx = 0;

    const ctx = gsap.context(() => {
      cards.forEach((card, i) => {
        if (i === cards.length - 1) return;

        ScrollTrigger.create({
          trigger: card,
          start: 'top 100px',
          endTrigger: cards[cards.length - 1],
          end: 'top 100px',
          pin: true,
          pinSpacing: false,
          onEnter: () => {
            currentIdx = i + 1;
            setActiveIdx(currentIdx);
          },
          onEnterBack: () => {
            currentIdx = i;
            setActiveIdx(currentIdx);
          },
        });

        gsap.to(card, {
          scale: 0.95,
          opacity: 0.45,
          y: -16,
          ease: 'none',
          scrollTrigger: {
            trigger: cards[i + 1],
            start: 'top bottom',
            end: 'top 100px',
            scrub: 1,
          },
        });
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="experience-section" id="experience" ref={sectionRef}>
      <div className="exp-header">
        <h2 className="exp-title">EXPERIENCE</h2>
        <div className="exp-counter">
          <span className="exp-counter-current">
            {String(activeIdx + 1).padStart(2, '0')}
          </span>
          <span className="exp-counter-sep">/</span>
          <span className="exp-counter-total">
            {String(experienceData.length).padStart(2, '0')}
          </span>
        </div>
      </div>

      <div className="exp-track" ref={trackRef}>
        {experienceData.map((item, idx) => (
          <div key={item.id} className="exp-stack-card">
            <div className="exp-card">
              <div className="exp-card-accent" aria-hidden="true" />

              <div className="exp-card-header">
                <div>
                  <h3 className="exp-role">{item.jobtitle}</h3>
                  <span className="exp-company">{item.company}</span>
                </div>
                <span className="exp-dates">
                  {item.startYear} — {item.endYear}
                </span>
              </div>

              <ul className="exp-details">
                {item.details.map((detail, dIdx) => (
                  <li key={dIdx}>{detail}</li>
                ))}
              </ul>

              <div className="exp-card-num" aria-hidden="true">
                {String(idx + 1).padStart(2, '0')}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Experience;
